<template>
  <v-dialog
    v-model="dialog"
    content-class="no-border overflow-hidden background"
    width="1200"
    @click:outside="cancel"
  >
    <div class="text-right">
      <v-btn
        @click="cancel"
        class="ma-2"
      >
        <v-icon>close</v-icon> Close
      </v-btn>
    </div>
    <v-carousel
      hide-delimiters
      height="calc(100vh - 100px)"
      :show-arrows="thumbnails.length > 1"
    >
      <v-carousel-item
        v-for="(thumb, i) in thumbnails"
        :key="i"
        class="mx-6"
      >
        <v-img
          :src="thumb"
          width="100%"
          class="my-auto"
          contain
        />
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'ImagePreview',
  props: {},
  data: () => ({
    dialog: false,
    saving: false,
    thumbnails: []
  }),
  computed: {
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    show(thumbnails) {
      this.thumbnails = cloneDeep(thumbnails);
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
#iframe {
  width: 100%;
  height: 100%;
}
</style>
